import * as ex from 'excalibur';
import { ControlType } from '../types/enums';
import { PlayerUnit } from './playerUnit';

// Player-controlled Imp
export class PlayerImp extends PlayerUnit {
  constructor(options: any) {
    super({
      gridX: options.gridX,
      gridY: options.gridY,
      type: 'imp',
      name: 'Imp',
      color: ex.Color.Green,
      initiative: options.initiative,
      health: 20,
      maxHealth: 20,
      moveRange: 2,
      attackRange: 1,
      abilities: ['hop_over'],
      grid: options.grid
    });

    // Imps are always automatic
    this.controlType = ControlType.Automatic;

    // Set the emoji for this unit type
    this.setEmoji("🏃"); // Runner for scout/fast unit
  }
}